import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Filter from 'modules/shared/common/components/Filter';
import {
  VendorsFilterWrapper,
  VendorsFilterSearchBarWrapper,
  VendorsFilterSearchBar,
  VendorsFilterSearchBarIcon,
} from './VendorsFilter.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const VendorsFilter = ({
  stringsData,
  filters,
  handleVendorsGenericFilterChange,
  handleVendorsSearchBarInputChange,
  labsQueryStrings,
}) => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################

  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleSearchBarInputChange = event => {
    const { value } = event.target;
    const searchQueryMinLength = 3;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        handleVendorsSearchBarInputChange(value);
      }, 300);
    }
    // this condition checks if we are deleteing letters from search query and we reached
    // 2 characters, then we need to clear search query filter
    else if (searchQuery.length >= searchQueryMinLength && value.length < searchQueryMinLength)
      handleVendorsSearchBarInputChange(value, true);
  };

  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <VendorsFilterWrapper>
      <VendorsFilterSearchBarWrapper>
        <VendorsFilterSearchBarIcon />
        <VendorsFilterSearchBar
          placeholder={stringsData.vendorsHeader.vendorsFilterSearchBarPlaceholder}
          value={searchQuery}
          onChange={event => handleSearchBarInputChange(event)}
          data-testid="vendorsSearch"
        />
      </VendorsFilterSearchBarWrapper>
      {filters?.dropDownFilters?.map(filterProps => {
        let isDisplayFilter = true;
        if (filterProps?.filterDisplayCondition)
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of Object.entries(filterProps.filterDisplayCondition)) {
            if (labsQueryStrings.hasOwnProperty(key)) {
              if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i += 1) {
                  const val = value[i].toString();
                  if (labsQueryStrings[key].includes(val)) {
                    isDisplayFilter = true;
                    break;
                  } else isDisplayFilter = false;
                }
              } else isDisplayFilter = true;
            } else isDisplayFilter = false;
          }

        return (
          isDisplayFilter && (
            <Filter
              key={filterProps.filterKey}
              handleGenericFilterClick={handleVendorsGenericFilterChange}
              filterProps={filterProps}
              ordersApiCallParams={labsQueryStrings}
            />
          )
        );
      })}
    </VendorsFilterWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

VendorsFilter.propTypes = {
  stringsData: PropTypes.shape({
    vendorsHeader: PropTypes.shape({
      vendorsFilterSearchBarPlaceholder: PropTypes.string,
    }),
  }).isRequired,
  handleVendorsSearchBarInputChange: PropTypes.func.isRequired,
  handleVendorsGenericFilterChange: PropTypes.func.isRequired,
  labsQueryStrings: PropTypes.shape({}).isRequired,
  filters: PropTypes.shape({
    dropDownFilters: PropTypes.arrayOf(PropTypes.shape({})),
    moreFilters: PropTypes.arrayOf(PropTypes.shape({})),
    searchByItemsFilter: PropTypes.bool,
  }),
};

VendorsFilter.defaultProps = {
  filters: {},
};

export default VendorsFilter;
